import { BaseApiError } from './base-api-error';

export class RateLimitError extends BaseApiError {
  public daysRemaining?: number;
  public nextAllowedDate?: string;

  constructor(message = 'Rate limit exceeded. Please try again later.') {
    super(message, 429);
    this.name = 'RateLimitError';
  }
}

export class ServerError extends BaseApiError {
  constructor(
    message = 'The server is currently unavailable. Please try again later.',
  ) {
    super(message, 500);
    this.name = 'ServerError';
  }
}

export class NetworkError extends BaseApiError {
  constructor(
    message = 'Unable to connect to the server. Please check your internet connection.',
  ) {
    super(message, 0);
    this.name = 'NetworkError';
  }
}

export class NotFoundError extends BaseApiError {
  constructor(message = 'The requested resource was not found.') {
    super(message, 404);
    this.name = 'NotFoundError';
  }
}

export class BadRequestError extends BaseApiError {
  constructor(message = 'The request was invalid.') {
    super(message, 400);
    this.name = 'BadRequestError';
  }
}

export class ConflictError extends BaseApiError {
  constructor(message = 'A conflict occurred.') {
    super(message, 409);
    this.name = 'ConflictError';
  }
}
